/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type BurgerIconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function BurgerIcon(props: BurgerIconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 22 14"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        d={"M0 14v-1.863h22V14zm0-6.068V6.068h22v1.864zm0-6.069V0h22v1.863z"}
      ></path>
    </svg>
  );
}

export default BurgerIcon;
/* prettier-ignore-end */
